import { InputModalityDetector } from '@angular/cdk/a11y';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [NgIf, NgClass, NgFor],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Default Title';
  @Input() titleColor: string = '#000000';
  @Input() buttons: {
    text: string;
    class: string;
    isDisabled?: boolean | (() => boolean);
    action: () => void;
  }[] = [];

  @Output() modalClosed: EventEmitter<void> = new EventEmitter();

  close() {
    this.isVisible = false;
    this.modalClosed.emit();
  }

  evaluateDisabled(button: {
    isDisabled?: boolean | (() => boolean);
  }): boolean {
    if (typeof button.isDisabled === 'function') {
      return button.isDisabled();
    }
    return button.isDisabled || false;
  }
}
